import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { RecommendationProps } from '@shared/widget-schemas';
import { capitalizeFirst } from './textFormat';

const priorityStyles = {
  high: 'bg-destructive/10 text-destructive border-destructive/30',
  medium: 'bg-warning/10 text-warning border-warning/30',
  low: 'bg-primary/10 text-primary border-primary/30',
} as const;

export function RecommendationWidget({
  recommendation_id,
  title,
  body,
  priority,
  onRecommendationDecision,
}: RecommendationProps & {
  onRecommendationDecision?: (action: 'accept' | 'decline') => void;
}) {
  return (
    <Card className="w-full">
      <CardHeader className="pb-2 flex-row items-center gap-2 space-y-0">
        <CardTitle className="text-base flex-1">{capitalizeFirst(title)}</CardTitle>
        <Badge className={cn('capitalize', priorityStyles[priority])}>{priority}</Badge>
      </CardHeader>
      <CardContent className="space-y-3 pt-0">
        <p className="text-sm text-muted-foreground">{capitalizeFirst(body)}</p>
        {recommendation_id && onRecommendationDecision ? (
          <div className="flex flex-wrap gap-2">
            <Button size="sm" variant="secondary" type="button" onClick={() => onRecommendationDecision('accept')}>
              Accept
            </Button>
            <Button size="sm" variant="outline" type="button" onClick={() => onRecommendationDecision('decline')}>
              Decline
            </Button>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
